import { Component, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { DesignRouteService, DesignSidenavComponent } from '@processpuzzle/design';
import { SidenavAutosizeDirective } from '@processpuzzle/widgets';
import { FooterComponent } from '../navigation/footer/footer.component';
import { HeaderComponent } from '../navigation/header/header.component';
import { SidenavComponent } from '../navigation/sidenav/sidenav.component';

/**
 * The platform's own chrome around the screens that *work on* the application rather than being it —
 * the designer and the administration of users — and around the no-organization and auth pages. The
 * application itself is `RuntimeHostComponent`, which renders whatever its definition says.
 *
 * Header, collapsible sidenav, routed content, footer — the same shell the admin application uses,
 * because a customer's workspace and a staff console differ in what they contain rather than in how
 * they are laid out.
 *
 * <p>With one addition the admin shell has no use for: the design-mode branch.
 * `DesignRouteService.isDesignRoute()` tells the designer from the administration. It is
 * prefix-aware — see `DESIGN_ROUTE_PREFIX` in `app.config.ts` — which is why it works at all here,
 * where the designer is at `/{orgKey}/design` rather than at the root it was written for.
 */
@Component({
  selector: 'app-workspace-shell',
  imports: [RouterModule, HeaderComponent, SidenavComponent, DesignSidenavComponent, FooterComponent, MatSidenav, MatSidenavContainer, MatSidenavContent, SidenavAutosizeDirective],
  templateUrl: './workspace-shell.component.html',
  styleUrl: './workspace-shell.component.scss',
})
export class WorkspaceShellComponent {
  readonly designRouteService = inject(DesignRouteService);
  readonly sidenavOpened = signal(true);

  toggleSidenav() {
    this.sidenavOpened.update((opened) => !opened);
  }
}
